import { AxiosError } from 'axios';
import { Modal } from 'react-bootstrap';
import api from '../../../services/cle';
import { useEffect, useState } from 'react';
import Spinner from '../../../rxlib/components/spinner';
import { SubmitHandler, useForm } from 'react-hook-form';
import { ApiError, FormExclusao } from '../../../services/tipos';
import { Exclusao } from '../../../rxlib/components/layout/exclusao';

interface OrganizacaoExclusaoProps {
    show: boolean;
    onHide: () => void;
    idOrganizacao: string;
    onExcluir: (valor: boolean) => void;
    tratarErro: (error: AxiosError<ApiError>, mensagem: string) => void;
}

function OrganizacaoExclusao(props: OrganizacaoExclusaoProps) {
    const [nome, setNome] = useState<string>('');
    const [carregando, setCarregando] = useState<boolean>(false);
    const [carregandoOrganizacao, setCarregandoOrganizacao] = useState<boolean>(false);

    const { handleSubmit } = useForm<FormExclusao>();

    useEffect(() => {
        if (props.show) {
            setCarregandoOrganizacao(true);
            api.get(`/Organizacao/${props.idOrganizacao}`)
                .then(response => {
                    setNome(response.data.nome);
                    setCarregandoOrganizacao(false);
                }).catch((error: AxiosError<ApiError>) => {
                    setCarregandoOrganizacao(false);
                    props.tratarErro(error, 'Não foi possível realizar a consulta: ');
                });
        }
    }, [props]);

    const onSubmit: SubmitHandler<FormExclusao> = data => {
        setCarregando(true);
        api.delete(`/Organizacao/${props.idOrganizacao}`, data)
            .then(response => {
                informarSucesso();
            }).catch((error: AxiosError<ApiError>) => {
                setCarregando(false);
                props.tratarErro(error, 'Não foi possível excluir a organização: ');
            });
    }

    function informarSucesso() {
        props.onHide();
        props.onExcluir(true);
        setCarregando(false);
    }

    return (
        <Modal show={props.show} onHide={props.onHide} dialogClassName='rxlib-modal-exclusao' centered>
            <Modal.Body className='rxlib-modal-exclusao-body'>
                {
                    carregandoOrganizacao
                        ? <Spinner
                            classStyle='rxlib-spinner' />
                        : <Exclusao
                            carregando={carregando}
                            onCancelar={props.onHide}
                            onSubmit={handleSubmit(onSubmit)}
                            titulo={`Deseja realmente excluir a organização ${nome}?`} />
                }
            </Modal.Body>
        </Modal>
    );
}

export default OrganizacaoExclusao;